import { createContext, useState, useEffect, useContext } from "react";
import Cookie from "js-cookie";
import axios from "axios";
import { BaseUrlApi, ErrorMessage } from "../lib/api";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const userToken = Cookie.get("token");
  const navigate = useNavigate();

  const [token, setToken] = useState(userToken);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (userToken) setToken(userToken);
  }, [userToken]);
  
  useEffect(() => {
    const userToken = Cookie.get("token");
    if (userToken) {
      const getProfile = async () => {
        try {
          setLoading(true);
          const { data } = await axios.get(`${BaseUrlApi}/me`);
          setUser(data.data);
        } catch (error) {
          Cookie.remove("token");
          setUser(null);
          navigate("/login");
          toast("Error", {
            description: ErrorMessage(error),
          });
        } finally {
          setLoading(false);
        }
      };
      getProfile();
    } else {
      setLoading(false);
    }
  }, [userToken]);

  // Logout function
  const logout = () => {
    setUser(null);
    setToken(null);
    Cookie.remove("token");
    navigate("/login", { replace: true });
  };

  return (
    <AuthContext.Provider value={{ user, loading, logout, token }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
